import axios from "@/lib/request";

// ===== 货险年保预核保订单相关接口 =====

// 获取预核保订单列表
export const getUnderwriteOrderList = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/list",
    method: "get",
    params: {
      product_name: "货运险年保",
      ...params
    },
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取预核保订单详情
export const getUnderwriteOrderInfo = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存预核保订单（新增）
export const saveUnderwriteOrder = (data) => {
  return axios.request({
    url: "/v1/admin/underwrite/hynb/order/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新预核保订单（编辑）
export const updateUnderwriteOrder = (data) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除预核保订单
export const deleteUnderwriteOrder = (data) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/delete",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 检查公司是否已有预核保订单
export const checkUnderwriteCompany = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/check/company",
    method: "get",
    params: {
      product_name: "货运险年保",
      ...params
    },
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新订单审核状态
export const updateUnderwriteOrderStatus = (data) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/update/status",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取人工核保参考信息
export const getUnderwriteManualInfo = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/manual/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取补充资料列表
export const getUnderwriteSupplementList = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/supplement/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取省份列表
export const getProvinceList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/province/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取城市列表
export const getCityList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/city/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取诉讼详情
export const getLitigationDetail = (params) => {
  return axios.request({
    url: "/v1/admin/underwrite/order/litigation/detail",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};
